import { render, staticRenderFns } from "./CustomersGrid.vue?vue&type=template&id=50bf30f2"
import script from "./CustomersGrid.vue?vue&type=script&lang=js"
export * from "./CustomersGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports